import React, { useEffect } from 'react';
import { auth } from "../../firebase/firebaseConfig";
import { onAuthStateChanged, signInWithEmailAndPassword } from "firebase/auth";
import './Login.css';
import secureLocalStorage from 'react-secure-storage';
import { Button, Input, message } from 'antd';

function Login () {
    const [ messageApi, contextHolder ] = message.useMessage();

    useEffect( () => {
        onAuthStateChanged( auth, ( user ) => {
            if ( user && secureLocalStorage.getItem( "login" ) ) {
                window.location.href = "/";
            }
        } );
    }, [] )

    return (
        <div className='login-body'>
            {contextHolder}
            <div className="login">
                <h1>Login</h1>
                <form onSubmit={async ( event ) => {
                    event.preventDefault();
                    messageApi.loading( "Logging you into the panel...", 0 );
                    signInWithEmailAndPassword( auth, event.target.email.value, event.target.password.value )
                        .then( () => {
                            secureLocalStorage.setItem( "login", true );
                            secureLocalStorage.setItem( "loginTime", new Date() );
                            messageApi.destroy();
                            messageApi.success( "Successfully logged into the panel." )
                            setTimeout( () => {
                                window.location.href = "/";
                            }, 500 )
                        } )
                        .catch( ( error ) => {
                            messageApi.destroy();
                            messageApi.error( "Invalid login details. Kindly check your email and password." )
                        } );
                }}>
                    <Input type="email" name='email' placeholder="Enter Email Id" autoFocus required />
                    <Input type="password" name='password' placeholder="Enter The Password" required />
                    <Button htmlType="submit" type='primary'>Login</Button>
                </form>
            </div>
        </div>
    )
}

export default Login